import { PLACE_ORDER_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(`${PLACE_ORDER_API}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json, status: response.status };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
